import React from 'react'
import { Row, Col } from 'react-bootstrap'
import { CerealVariedadDropdown, EntityAutocomplete } from '../../../Forms/SharedComponents/containers'
import { Button } from '@material-ui/core'
import DatePicker from '../../../LaridaeApp/datepicker/container/DatePicker'
import { Field } from 'redux-form'
import { renderTextField } from '../../../Forms/fieldRenderers'

function CamposVentaExportador (props) {
  const { handleSubmit, actualizarFecha, actualizacion = false } = props

  return (
    <Row style={{ display: 'flex', justifyContent: 'center' }}>
      <Col md={6}>
        <EntityAutocomplete
          name='exportadorVenta'
          label='Exportador *'
          entity='exportador'
          placeholder='Exportador - 19999999991'
          value={''}
        />
      </Col>

      <Col md={6}>
        <CerealVariedadDropdown fieldNameCereal={'cerealVenta'} />
      </Col>

      <Col md={4}>
        <DatePicker
          locale='es'
          disabledFuture
          onDateChange={actualizarFecha}
          titulo='Seleccione la fecha de venta *'
          value='fechas'
        />
      </Col>
      <Col md={4}>
        <Field
          name='cantidad'
          label='Cantidad (kgs.) *'
          component={renderTextField}
        />
      </Col>

      {!actualizacion &&
        <Col md={4} style={{ display: 'flex', alignItems: 'center', marginTop: '10px', width: '90%' }}>
          <Button
            onClick={handleSubmit}
            variant='contained'
            color='primary'
          >
            Vender
          </Button>
        </Col>
      }
      <Col md={12} style={{ textAlign: 'rigth', marginTop: '8px' }}>
        <p>(*) Campo requerido obligatorio</p>
      </Col>
    </Row>
  )
}

export default CamposVentaExportador
